import './ImagePlaceholder/styles.css';

export function ProjectExplorerPreview({ title, wide = false }) {
  const classes = ['imgPlaceholder', wide ? 'imgPlaceholderWide' : ''].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className="imgPlaceholderTop">
        <p className="imgPlaceholderHeading">{title || 'Project Explorer'}</p>
        <div className="imgPlaceholderFilters">
          <span className="imgPlaceholderFilter">Filter: Tech</span>
          <span className="imgPlaceholderFilter">Tags: Python</span>
        </div>
      </div>
      <div className="imgPlaceholderBody">
        <article className="imgPlaceholderCard">
          <div className="imgPlaceholderThumb" />
          <div className="imgPlaceholderContent">
            <p className="imgPlaceholderCardTitle">Eco-Tracking App</p>
            <p className="imgPlaceholderCardMeta">Looking for: UI Designer, Data Scientist</p>
            <span className="imgPlaceholderChip">ETH Zurich</span>
          </div>
        </article>
        <article className="imgPlaceholderCard">
          <div className="imgPlaceholderThumb imgPlaceholderThumbAlt" />
          <div className="imgPlaceholderContent">
            <p className="imgPlaceholderCardTitle">MedTech Wearable</p>
            <p className="imgPlaceholderCardMeta">Looking for: Hardware Engineer</p>
            <span className="imgPlaceholderChip">Imperial College</span>
          </div>
        </article>
      </div>
    </div>
  );
}

